export default __webpack_public_path__ + "static/media/alipay.b0a8d67a.svg";